// ##############################
// // // User form view styles
// #############################

const registerPageStyle = {
    center: {
        textAlign: 'center'
    },
    form: {
        padding: '0 20px',
        position: 'relative'
    },
};

export default registerPageStyle;



// WEBPACK FOOTER //
// ./src/layouts/UserCreate/styles.js